import styled, { css, keyframes } from 'styled-components';
import LabelIcon from '../icons/label';
import ChevronDown from '../icons/chevronDown';

export const Container = styled.div`
  display: flex;
  height: 100%;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
`;

export const BadgeContainer = styled.div<{ clickable?: boolean }>`
    display: inline-flex;
    cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
    transition: ${(props) => (props.clickable ? 'transform 0.1s ease-in-out' : 'none')};
    &:hover {
        transform: ${(props) => (props.clickable ? 'scale(1.03)' : 'none')};
    }
`;

export const BadgesGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.50rem;
    width: 100%;
`;

export const StyledChevron = styled(ChevronDown).withConfig({
    shouldForwardProp: (prop) => !['expanded'].includes(prop),
})<{ expanded?: boolean }>`
    width: 0.875rem;
    height: 0.875rem;
    margin-right: 0.25rem;
    transition: transform 0.25s ease-in-out;
    
    ${(props) => props.expanded && css`
        transform: rotate(180deg);
    `}
`;

export const TagIcon = styled(LabelIcon)`
    width: 1rem !important;
    height: 1rem !important;
    margin-right: 0.25rem;
    margin-bottom: 1px;
    flex-shrink: 0;
    vertical-align: middle;
`;

export const TooltipContent = styled.div`
    padding: 8px;
    min-width: 220px;
    max-width: 320px;
`;

export const TagHeader = styled.h1`
    font-size: 0.85rem;
    font-weight: 600;
    text-align: left;
    position: relative;
    margin-bottom: 6px;
`;

export const TagDescription = styled.p`
    font-size: 0.85rem;
    line-height: 1.5;
    text-align: left;
`;

const shimmer = keyframes`
    0% {
        background-position: -200px 0;
    }
    100% {
        background-position: 200px 0;
    }
`;

export const LoadingContainer = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const loadingBarShimmer = css`
    background: linear-gradient(to right, rgba(255, 255, 255, 0.05) 8%, rgba(255, 255, 255, 0.15) 18%, rgba(255, 255, 255, 0.05) 33%);
    background-size: 400px 104px;
    animation: ${shimmer} 1.2s infinite linear;
`;

export const LoadingBar = styled.div`
    height: 8px;
    border-radius: 4px;
    overflow: hidden;
    ${loadingBarShimmer}
`;

export const LoadingBarMedium = styled(LoadingBar)`
    width: 85%;
`;
